<template>
  <section id="experience" class="experience timeline-section">
    <h2 class="timeline-title">{{ $t("experience.title") }}</h2>
    <div class="timeline">
      <div v-for="(item, idx) in experiences" :key="idx" class="timeline-item">
        <div class="timeline-dot"></div>
        <div class="timeline-content">
          <h3 class="job-title">{{ item.position }}</h3>
          <span class="company">{{ item.company }}</span>
          <span class="period">{{ item.period }}</span>
          <p class="description">{{ item.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ExperienceTimeline",
  computed: {
    experiences() {
      return this.$tm("experience.items");
    },
  },
};
</script>

<style scoped>
.timeline-section {
  padding: 60px 20px;
  max-width: 1200px;
  margin: auto;
  text-align: center;
}
.timeline-title {
  margin-bottom: 40px;
  color: #333;
}
.timeline {
  position: relative;
  margin: 0 auto;
  padding: 20px 0;
  width: 100%;
}
.timeline:before {
  content: "";
  position: absolute;
  left: 24px;
  top: 0;
  width: 3px;
  height: 100%;
  background: #42b983;
  border-radius: 2px;
  z-index: 0;
}
.timeline-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 40px;
  position: relative;
}
.timeline-dot {
  width: 12px;
  height: 12px;
  background: #fff;
  border: 4px solid #42b983;
  border-radius: 50%;
  position: relative;
  left: 16px;
  z-index: 2;
  box-shadow: 0 2px 8px rgba(66, 185, 131, 0.15);
  transition: background 0.3s;
}
.timeline-content {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.07);
  padding: 18px 24px;
  margin-left: 48px;
  text-align: left;
  min-width: 0;
  flex: 1;
}
.job-title {
  margin: 0 0 6px 0;
  font-size: 1.15rem;
  color: #222;
}
.company {
  font-weight: 600;
  color: #42b983;
  display: block;
  margin-bottom: 2px;
}
.period {
  font-size: 0.95rem;
  color: #888;
  display: block;
  margin-bottom: 10px;
}
.description {
  color: #555;
  font-size: 0.97rem;
}
@media (max-width: 600px) {
  .timeline:before {
    left: 10px;
  }
  .timeline-dot {
    left: -2px;
  }
  .timeline-content {
    margin-left: 32px;
    padding: 14px 12px;
  }
}
/* Dark mode */
.dark-mode .timeline-section,
.dark-mode .timeline-title {
  color: #f0f0f0;
}
.dark-mode .timeline-content {
  background: #23233a;
  color: #f0f0f0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
}
.dark-mode .timeline:before {
  background: #42b983;
}
.dark-mode .timeline-dot {
  background: #23233a;
  border-color: #42b983;
}
.dark-mode .job-title {
  color: #fff;
}
.dark-mode .company {
  color: #42b983;
}
.dark-mode .period {
  color: #bbb;
}
.dark-mode .description {
  color: #e0e0e0;
}
</style>
